import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MeterConsumptionGranularityTypes } from '@app/shared/enums';
import { MeterDownloadWizardFilter } from '@app/shared/models/meter/meter-download-wizard-data';
import { MeterDownloadWizardUtility } from '../meter-download-wizard-utility';

@Component({
  selector: 'app-granularity-selection',
  templateUrl: './granularity-selection.component.html',
  styleUrls: ['./granularity-selection.component.scss'],
})
export class GranularitySelectionComponent implements OnInit {
  @Input() filter: Partial<MeterDownloadWizardFilter> = {} as MeterDownloadWizardFilter;
  @Output() title = new EventEmitter<string>();
  @Output() nextButtonStatus = new EventEmitter<boolean>();
  @Output() granularity = new EventEmitter<string>();

  MeterConsumptionGranularityTypes = MeterConsumptionGranularityTypes;
  granularityOptions: string[] = [];
  granularityEnum = MeterConsumptionGranularityTypes;

  constructor(public translate: TranslateService) {}

  public ngOnInit() {
    this.granularityOptions = Object.keys(this.granularityEnum);
    this.title.emit(this.translate.instant('module.shared.excelDownloadWizard.titleText1'));
    this.nextButtonStatus.emit(MeterDownloadWizardUtility.isNextButtonDisabled(this.filter.granularity));
  }

  public onSelectionChange(value: string) {
    this.granularity.emit(value);
    this.nextButtonStatus.emit(false);
  }
}
